"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.handleClose = exports.handleOpen = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _EventUtils = require("../EventUtils");

var _KeyboardUtils = _interopRequireDefault(require("../KeyboardUtils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var handleOpen = function handleOpen(_ref) {
  var onOpen = _ref.onOpen,
      onToggle = _ref.onToggle,
      open = _ref.open;

  if (onOpen) {
    onOpen();
  } else if (onToggle && !open) {
    onToggle();
  }
};

exports.handleOpen = handleOpen;

var handleClose = function handleClose(_ref2) {
  var onClose = _ref2.onClose,
      onToggle = _ref2.onToggle,
      open = _ref2.open;

  if (onClose) {
    onClose();
  } else if (onToggle && open) {
    onToggle();
  }
};

exports.handleClose = handleClose;

var popsOver = function popsOver(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class() {
      var _context;

      var _this;

      (0, _classCallCheck2.default)(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _underscore.default.extend({}, _this.props.initialState));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleOpen", function () {
        _this.setState({
          open: true
        });

        handleOpen(_this.props);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClose", function () {
        _this.setState({
          open: false
        });

        handleClose(_this.props);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
        if (_this._isOpen()) {
          _this._handleClose();
        } else {
          _this._handleOpen();
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleGlobalClick", function (e) {
        // handle click outside of container
        var domRef = _this.component.popperContainer ? _this.component.popperContainer.popper : _this.component;
        (0, _EventUtils.callIfOutsideOfContainer)(_reactDom.default.findDOMNode(domRef), _this._handleClose, e);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleGlobalKeyDown", function (e) {
        // handle escape key
        if (e.keyCode === _KeyboardUtils.default.KeyCodes.ESC) {
          _this._handleClose();
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_bindWindowsEvents", function () {
        var _context2;

        // bind once current execution stack is cleared (e.g. current window event processed).
        // to avoid possible false positive triggers if tooltip was open as result of click outside of it (e.g. some link outside)
        _underscore.default.defer((0, _bind.default)(_context2 = function _context2() {
          window.addEventListener("click", this._handleGlobalClick);
          window.addEventListener("keydown", this._handleGlobalKeyDown);
        }).call(_context2, (0, _assertThisInitialized2.default)(_this)));
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_removeWindowsEvents", function () {
        window.removeEventListener("click", _this._handleGlobalClick);
        window.removeEventListener("keydown", _this._handleGlobalKeyDown);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isOpen", function () {
        return _this.props.open !== undefined ? _this.props.open : _this.state.open;
      });
      return _this;
    }

    (0, _createClass2.default)(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this._isOpen()) {
          this._bindWindowsEvents();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (this.props.open !== undefined) {
          if (this._isOpen() && !prevProps.open) {
            this._bindWindowsEvents();
          } else if (!this._isOpen() && prevProps.open) {
            this._removeWindowsEvents();
          }
        } else {
          if (this._isOpen() && !prevState.open) {
            this._bindWindowsEvents();
          } else if (!this._isOpen() && prevState.open) {
            this._removeWindowsEvents();
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._removeWindowsEvents();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          onClose: this._handleClose,
          onOpen: this._handleOpen,
          onToggle: this._handleToggle,
          open: this._isOpen(),
          ref: function ref(el) {
            return _this2.component = el;
          }
        }));
      }
    }]);
    return _class;
  }(_react.default.Component), (0, _defineProperty2.default)(_class, "propTypes", {
    initialState: _propTypes.default.object,
    onClose: _propTypes.default.func,
    onOpen: _propTypes.default.func,
    onToggle: _propTypes.default.func,
    open: _propTypes.default.bool
  }), _temp;
};

var _default = popsOver;
exports.default = _default;